import { Box, Stack } from "@mui/material";
import React from "react";

import MilestoneProgressBars from "../progressBar/milestoneProgressBar";
import EditMIlestone from "../../../../components/Milestone/EditMilestone";
import MergeMilestonePopUp from "../mergeMilestone/MergeMilestonePopUp";
import GantChartSwitch from "../milestoneGantchart";
import { useMilestoneSectionState } from "./hooks/useMilestoneSectionState";

function MilestoneSection({ boardName }) {
  const {
    allMilestones,
    editMilestone,
    handleMilestoneClick,
    isMobile,
    milestoneSummary,
    openMergeMilestone,
    selectedMilestoneData,
    setEditMilestone,
    setOpenMergeMilestone,
  } = useMilestoneSectionState();

  return (
    <>
      <div className="milestone-cont" onClick={handleMilestoneClick}>
        <Stack
          direction="row"
          flexWrap={"wrap"}
          rowGap={isMobile ? 1 : 1.5}
          alignItems="center"
          justifyContent="space-between"
          spacing={isMobile ? 0 : 4}
          width="100%"
          pt={isMobile ? "4px" : ""}
        >
          {
          !isMobile && (
            <Stack direction="row" alignItems="center">
              <GantChartSwitch />
            </Stack>
          )}
          
          <Box className="milestone-progress">
            <MilestoneProgressBars
              allocatedHours={milestoneSummary.allocatedHours}
              hoursSpent={milestoneSummary.hoursSpent}
              exceedHours={milestoneSummary.exceedHours}
              remainingHours={milestoneSummary.remainingHours}
            />
          </Box>
          <Stack>
            <Stack direction="row" className={`d-flex align-items-center ${isMobile ? "mobile-milestone-date-container" : ""}`}>
              <p className="milestone_label">Target Date {isMobile ? "" : ": "} </p>
              <p className="milestone_value" style={{ marginLeft: "4px" }}>
                {milestoneSummary.targetDate}
              </p>
            </Stack>
          </Stack>
        </Stack>
      </div>
      {editMilestone && (
        <EditMIlestone
          boardName={boardName}
          open={editMilestone}
          handleClose={() => setEditMilestone(false)}
        />
      )}
      {openMergeMilestone && (
        <MergeMilestonePopUp
          open={openMergeMilestone}
          close={setOpenMergeMilestone}
          unlockedMilestone={allMilestones}
          isSelectSourceMilestone={true}
          SelectedSourceMileStone={selectedMilestoneData}
        />
      )}
    </>
  );
}

export default MilestoneSection;
